/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import {
  Label,
  Modal,
  TeamLogo,
  LargeButton,
  LoginWrapper,
  TextboxWarning,
  InputComponent,
  TestimonialLogin,
} from '../../components';
import {
  Or,
  Border,
  Hyperlink,
  LoginLogo,
  LoginForm,
  FormField,
  LabelForm,
  LoginLink,
  LoginLogoSpan,
  ModalBackground,
  CloseModalButton,
  MembershipSection,
  MembershipMessage,
} from './styles';
import { RenewSuscription } from './';
import { Utils } from '../../utils/api';
import { useHistory } from 'react-router-dom';
import { Auth as AuthClass } from '../../utils/api/';
import { ARMcontext } from '../../utils/context/context';
import { useInputValue } from '../../utils/hooks/useInputValue';

export default () => {
  const utils = new Utils();
  const Auth = new AuthClass();
  const history = useHistory();
  const { HandleUser } = React.useContext(ARMcontext);

  const UserName = useInputValue('');
  const [modal, useModal] = useState(false);
  const [userObj, useUserObj] = useState('');
  const [loading, useLoading] = useState(false);
  const isValidEmail = utils.GetValidationEmailPattern();
  const [renewSuscription, setRenewSuscription] = useState<boolean>(false);
  const [subscriptionData, setSubscriptionData] = useState<Object>({});
  const password = useInputValue('', 'eyeClose', '', '', 'password');

  function HandlePassword() {
    history.push({
      pathname: '/forgot-password',
      state: {
        email: UserName.value
      }
    })
  }

  async function HandleLogin(evt) {
    evt.preventDefault();
    if (!Boolean(UserName.value.length)) {
      UserName.HandleWarningTitle('Fill the email address information');
      UserName.HandleWarning('You’ll need your address to sign in to your coach portal');
      UserName.HandleStatus('error');
    } else if (!Boolean(isValidEmail.test(UserName.value))) {
      UserName.HandleWarningTitle('Incorrect email');
      UserName.HandleWarning('Please enter a valid email');
      UserName.HandleStatus('error');
    } else if (!Boolean(password.value.length)) {
      password.HandleWarningTitle('Fill the password information');
      password.HandleWarning(Link);
      password.HandleStatus('error');
    }
    //two emails were added to simulate the cases when a subscription has expired
    //These two cases will be eliminated when the integration is done.
    else if (UserName.value === 'organization@yopmail.com') {
      setSubscriptionData({
        description: 'The organization you belong to must renew the subscription so there is no lapse in the service.',
        subscriptionStart: 'Aug 12, 2022',
        subscriptionExpire: 'Aug 12, 2023',
        labelButton: 'Return to login screen',
        callback: () => setRenewSuscription(false)
      })
      setRenewSuscription(true)
    } else if (UserName.value === 'coach@yopmail.com') {
      setSubscriptionData({
        description: 'Your subscription has expired, renew your information to use the platform and add text here to keep the user informated about this account and the charge.',
        subscriptionStart: 'Aug 12, 2022',
        subscriptionExpire: 'Aug 12, 2023',
        labelButton: 'Renew subscription',
        callback: () => setRenewSuscription(false)
      })
      setRenewSuscription(true)
    }
    // <--------------------------
    else {
      useLoading(true);

      const res: any = await Auth.login(UserName.value.trim(), password.value);
      if (res.status) {
        history.push(history.location.pathname === '/login' ? res.data.role === 'player'?'/player-portal' : '/team' : history.location.pathname);
        if (res?.data?.membership?.membershipStatus !== 'OK' && res.data.role !== 'player') {
          useUserObj(res.data);
          useModal(true);
        } else {
          HandleUser(res.data);
          const {timeZone} = Intl.DateTimeFormat().resolvedOptions()
          if(res.data.role !== 'player' )
            await Auth.updateTimeZone(timeZone)
        }
      } else {
        const errorExeption = 'Specified account does not exist';
        const errorInactiveAccount = 'Account is inactive';
        const errorMessage = res?.data?.error?.charAt(0).toUpperCase() + res?.data?.error?.slice(1).replaceAll('_', ' ');
        if (errorMessage === errorExeption) {
          UserName.HandleWarningTitle('Account does not exist');
          UserName.HandleWarning(errorExeption);
          UserName.HandleStatus('error');
        } else if(errorMessage === errorInactiveAccount){
          UserName.HandleWarningTitle('Account is Inactive');
          UserName.HandleStatus('error');
        }
        else {
          password.HandleWarningTitle('Incorrect email or password');
          password.HandleWarning(Link);
          password.HandleStatus('error');
        }
        useLoading(false);
      }
    }
  }

  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }

  function HandleIcon(hook: any) {
    if (hook.icon === 'eyeClose') {
      hook.HandleIcon('eyeOpen');
      hook.HandleType('text');
    } else if (hook.icon === 'eyeOpen') {
      hook.HandleIcon('eyeClose');
      hook.HandleType('password');
    }
  }

  function manageModalButton(user): void {
    if (user.membership?.membershipStatus === 'Inactive') {
      if (user.role === 'org-admin') {
        window.open('https://armcare.com/my-account/payment-methods/', '_blank');
      }

      useModal(false);
      useLoading(false);
    }
    if (user.membership?.membershipStatus === 'Grace Period') {
      if (user.role === 'org-admin') {
        window.open('https://armcare.com/my-account/payment-methods/', '_blank');
      }
      HandleUser(user as string);
      useModal(false);
      history.push('/teams');
    }
  }

  function closeModal() {
    useModal(false);
    useLoading(false);
  }

  const Link = () => {
    return (
      <div>
        Did you <Hyperlink
          onClick={HandlePassword}>forgot password?
        </Hyperlink>
      </div>
    )
  }

  return (
    <>
      {modal && (
        <>
          {(userObj as any)?.membership?.membershipStatus !== 'OK' && (
            <ModalBackground onClick={() => closeModal()}>
              <Modal title="Payment Failed" margin="10vh auto 200px auto" padding={'20px 40px 15px 40px'}>
                <MembershipSection>
                  <MembershipMessage>
                    {(userObj as any)?.role === 'org-admin' && 'Please update your payment method so there is no lapse in service.'}
                    {(userObj as any)?.role === 'coach' &&
                      'Your account owner should update the payment method so there is no lapse in the service.'}
                  </MembershipMessage>
                  {(userObj as any)?.role === 'org-admin' && (
                    <LargeButton
                      callback={() => manageModalButton(userObj as any)}
                      rColor="#FF2608"
                      lColor="#E12107"
                      title="PAY MEMBERSHIP"
                      fColor="#FFF"
                      icon="plus"
                      xMargin={'16PX 0PX 21PX 40PX'}
                    />
                  )}
                  {(userObj as any)?.role === 'coach' && (
                    <CloseModalButton onClick={() => manageModalButton(userObj as any)}>OK</CloseModalButton>
                  )}
                </MembershipSection>
              </Modal>
            </ModalBackground>
          )}
        </>
      )}

      <LoginWrapper isLoading={loading} topLoader={220}>
        <>
          <LoginLogo data-cy="login-logo">
            <TeamLogo mWidth="200px" mHeight="40px" />
            <LoginLogoSpan>Measure. Monitor. Optimize</LoginLogoSpan>
          </LoginLogo>
          {renewSuscription ? (
            <RenewSuscription subscriptionData={subscriptionData} />
          ) : (
            <LoginForm onSubmit={HandleLogin} data-cy="login">
              <FormField data-cy="login-username">
                <LabelForm>
                  <Label text="Email Address" color={'#38424D'} fontSize={'16px'} fontWeight={'600'} />
                </LabelForm>
                <InputComponent
                  fontSize={16}
                  maxLength={100}
                  autoComplete="on"
                  inputStyle="dark"
                  disabled={loading}
                  bordeRadius={'4px'}
                  dynamicSearch={UserName}
                  insetShadow="#F4F5F7"
                  placeholder="your@email.com"
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  HandleFocus={() => HandleFocus(UserName)}
                />
                <TextboxWarning status={UserName.status} title={UserName.warningTitle} message={UserName.warningMessage} />
              </FormField>
              <FormField data-cy="login-password">
                <LabelForm>
                  <Label text="Password" color={'#38424D'} fontSize={'16px'} fontWeight={'600'} />
                  <Label text="Forgot Password?" color="#007AFF" fontSize={'16px'} cursor="pointer" callback={HandlePassword} />
                </LabelForm>
                <InputComponent
                  fontSize={16}
                  autoComplete="on"
                  disabled={loading}
                  bordeRadius={'4px'}
                  dynamicSearch={password}
                  insetShadow="#F4F5F7"
                  placeholder="password here"
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  HandleIcon={() => HandleIcon(password)}
                  HandleFocus={() => HandleFocus(password)}
                  inputStyle={password.status === 'error' ? 'error' : 'dark'}
                />
                <TextboxWarning
                  inputStyle={'error'}
                  status={password.status}
                  title={password.warningTitle}
                  message={password.warningMessage}
                />
              </FormField>
              <LargeButton
                fullWidth
                lMargin="0"
                type="submit"
                title="Login"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#017CFF"
                bColor="#FFFFFF"
                disabled={loading}
                xMargin={'63px 0 0;'}
                dataCy="login-button"
                callback={HandleLogin}
                colorDisabled={'#B3D7FF'}
              />
              <LoginLink>
                <Border />
                <Or>Or</Or>
                <Border />
              </LoginLink>
              <LargeButton
                fullWidth
                lMargin="0"
                fColor="#000"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#FBFCFD"
                disabled={loading}
                title="Create account"
                callback={() => history.push('/create-account')}
              />
            </LoginForm>
          )}

          <TestimonialLogin />
        </>
      </LoginWrapper>
    </>
  );
};
